<template>
    <div class="text-center">
        <b-button-group v-if="nbHits > 0">
            <b-button v-if="value > 1" variant="none" @click="$emit('input', 1)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-double-left" />&emsp;
            </b-button>
            <b-button
                v-if="value > 1"
                variant="none"
                @click="$emit('input', value - 1)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-left" />&emsp;
            </b-button>
            <b-button variant="none" disabled>{{ value }} / {{ nbPages }}</b-button>
            <b-button
                v-if="value < nbPages"
                variant="none"
                @click="$emit('input', value + 1)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-right" />&emsp;
            </b-button>
            <b-button
                v-if="value < nbPages"
                variant="none"
                @click="$emit('input', nbPages)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-double-right" />&emsp;
            </b-button>
        </b-button-group>
        <p>{{ nbHits | baseNumberFormatter }} 件のデータが見つかりました</p>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
            default: 1,
        },
        nbPages: {
            type: Number,
            required: true,
            default: 0,
        },
        nbHits: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    data() {
        return {}
    },
    computed: {},
    async mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped>
.filter-item-option {
    display: block;

    &[active] {
    }

    &:not([active]) {
        opacity: 0.3;
    }

    [type='radio'] {
        display: none;
    }

    .filter-item-option-text {
        cursor: pointer;
    }
}
</style>


